import * as types from './mutation-types'
import ClientDB from '@/rahmen/clientDB'
import conf from '@/rahmen/conf'
import HttpClient from '@/rahmen/httpClient'

export const loadMasters = ({ commit, state }, { list, version, kinoId }) => {
  console.log(types.SAVE_MASTERS, list, version)

  return new Promise((resolve) => {
    const apiVersion = version || 1

    const promises = list.map((c) => {
      return new Promise((resolve) => {
        console.log(c)
        const url = _getUrl(state, c, apiVersion)
        console.log('_getUrl', state, c, url)
        const exists = _existsMasterdata(state, c)

        _readMasterFromDB(c, exists, state).then(({ value }) => {
          console.log(types.SAVE_MASTERS, 'readMasterFromDB__', c, exists, value)
          if (value !== undefined && value !== null) {
            console.log(types.SAVE_MASTERS, 'readMasterFromDB_restored', c, exists, value)
            commit(types.SAVE_MASTERS, { id: c, data: value })
          }

          const httpClient = new HttpClient(kinoId)
          httpClient.get(url).then((data) => {
            console.log(types.SAVE_MASTERS, 'httpClient', url, data)
            if (data.payload !== null) {
              const m = _mergeData(state[c], data.payload)
              console.log(types.SAVE_MASTERS, 'mergeData', m)
              commit(types.SAVE_MASTERS, { id: c, data: m })
              _saveMasterToDB(c, m)
              // resolve()
            }
          })
          resolve()
        })
      })
    })

    Promise.all(promises).then(() => {
      resolve()
    })
  })
}

export const loadMenuOshirase = ({ commit, state }, { userId }) => {
  var version = 1
  console.log(types.SAVE_MASTERS, version)

  return new Promise((resolve) => {
    const apiVersion = version || 1
    const url = `/api/v${apiVersion}/msysmenuoshirase/GetAllTopMenu?userid=${userId}`
    const exists = _existsMasterdata(state, 'msysmenuoshirase')

    _readMasterFromDB('msysmenuoshirase', exists, state).then(({ value }) => {
      console.log(types.SAVE_MASTERS, 'readMasterFromDB', 'msysmenuoshirase', exists, value)
      if (value !== undefined && value !== null) {
        commit(types.SAVE_MASTERS, { id: 'msysmenuoshirase', data: value })
      }
      const httpClient = new HttpClient()
      httpClient.get(url).then((data) => {
        console.log(types.SAVE_MASTERS, 'httpClient', url, data)
        if (data.payload !== null) {
          const m = _mergeData(state.msysmenuoshirase, data.payload)
          console.log(types.SAVE_MASTERS, 'mergeData', m)
          commit(types.SAVE_MASTERS, { id: 'msysmenuoshirase', data: m })
          _saveMasterToDB('msysmenuoshirase', m)
          resolve()
        }
      })
    })
  })
}

export const saveMasters = ({ commit, state }, masters) => {
  const list = Object.keys(masters).filter(m => {
    return state.certificateMasters.includes(m.toLocaleLowerCase())
  })
  list.forEach((m) => {
    commit(types.SAVE_MASTERS, { id: m.toLowerCase(), data: masters[m] })
    _saveMasterToDB(m.toLowerCase(), masters[m])
  })
}

export const restoreMasters = ({ commit, state }) => {
  return new Promise((resolve) => {
    const promises = state.certificateMasters.filter((m) => {
      console.log('_existsMasterdata.filter', m, state[m])
      return true //! _existsMasterdata(state, m)
    }).map((m) => {
      console.log('_existsMasterdata.map', m, state[m])
      return _readAndLoadToMemory({ commit, state }, m)
    })
    Promise.all(promises).then(() => {
      resolve()
    })
  })
}

export const truncateMasters = ({ commit }, { list }) => {
  return new Promise((resolve) => {
    const promises = list.map((c) => {
      return new Promise((resolve) => {
        commit(types.SAVE_MASTERS, { id: c, data: [] })
        _saveMasterToDB(c, [])
        resolve()
      })
    })
    Promise.all(promises).then(() => {
      resolve()
    })
  })
}

export const getCurrentKinoName = ({ state }, id) => {
  return new Promise((resolve) => {
    getKinoRecord({ state }, id).then((k) => {
      if (k === undefined || id === 0) {
        if (id !== 0) console.error(`対象のIDを持つ機能名が存在しません。機能ID:${id}`)
        resolve('')
      } else {
        resolve(k.kinoNm)
      }
    })
  })
}

export const getKinoRecord = ({ state }, id) => {
  return new Promise((resolve) => {
    const k = state.msyskino.find((m) => {
      return m.id === id
    })
    if (k === undefined || id === 0) {
      if (id !== 0) console.error(`対象のIDを持つ機能マスタが存在しません。機能ID:${id}`)
      resolve()
    }
    resolve(k)
  })
}

export const getSavedInputs = ({ state }, kinoId) => {
  return new Promise((resolve) => {
    const list = state.msysinputsave.filter((m) => {
      return m.mstKinoId === kinoId
    })
    const result = {}
    list.forEach(l => {
      result[l.itemNm] = l.fukugenchi
    })
    console.log('DDMasters.actions.getSavedInputs', result, list)
    resolve(result)
  })
}

export const getOshiraseMessage = ({ state }, hasseimotoKbn) => {
  return new Promise((resolve) => {
    const param = state.msysmenuoshirase.find((m) => {
      return m.hasseimotoKbn === hasseimotoKbn
    })
    resolve(param)
  })
}

export const registerSavedInput = ({ commit, state }, { kinoId, obj }) => {
  console.log('DDMasters.actions.registerSavedInput', kinoId, obj)
  return new Promise((resolve) => {
    const param = {}
    if (obj === undefined || obj === null || Object.keys(obj).length === 0) {
      resolve()
      return
    }
    Object.keys(obj).forEach(o => {
      param[o] = obj[o]
      const row = state.msysinputsave.find(m => {
        return m.mst_kino_id === kinoId && m.itemNm === o
      })
      if (row === undefined) { return }
      const index = state.msysinputsave.indexOf(row)
      if (index === -1) { return }
      commit(types.UPDATE_SAVED_INPUT, { index, row })
    })

    const httpClient = new HttpClient()
    const posturl = '/api/v1/MsysInputSave/BulkRegister'
    httpClient.post(posturl, param).then((data) => {
      if (data.payload !== null) {
        const m = _mergeData(state.msysinputsave, data.payload)
        console.log(types.SAVE_MASTERS, 'mergeData', m)
        commit(types.SAVE_MASTERS, { id: 'msysinputsave', data: m })
        _saveMasterToDB('msysinputsave', m)
      }
      resolve()
    }).catch((data) => {
      console.error(data)
      resolve()
    })
  })
}

export const getKengen = ({ state }, { kinoId, groupCd }) => {
  console.log('DDMasters/getKengen', kinoId, groupCd)
  return new Promise((resolve) => {
    const groupId = state.mstkengengroup.id

    const menuDetail = state.msysmenudetail.find((m) => {
      return m.mstKinoId === kinoId
    }) || {}

    const kengen = state.mstkengen.find((m) => {
      return m.mstMenuDetailId === menuDetail.id && m.mstKengenGroupId === groupId
    })

    if (kengen === undefined) {
      if (groupId !== undefined) console.error(`対象の権限が存在しません。権限グループID:${groupId} 機能ID:${kinoId}`)
      resolve()
    } else {
      resolve(kengen)
    }
  })
}

const _readAndLoadToMemory = ({ commit, state }, m) => {
  return new Promise((resolve) => {
    _readMasterFromDB(m, false, state).then(({ value }) => {
      console.log('_readAndLoadToMemory', 'readMasterFromDB', m, value)
      if (value !== undefined && value !== null) {
        commit(types.SAVE_MASTERS, { id: m, data: value })
      }
      resolve()
    })
  })
}

const _existsMasterdata = (state, c) => {
  console.log('_existsMasterdata', c, state[c] === undefined, state[c] === [], state[c] === {}, state[c].length === 0)
  return !(
    state[c] === undefined ||
    state[c] === [] ||
    state[c] === {} ||
    // eslint-disable-next-line dot-notation
    state[c]['length'] === 0)
}

const _getUrl = (state, c, v) => {
  if (!_existsMasterdata(state, c)) {
    return `/api/v${v}/${c}/getall`
  } else {
    const tsList = state[c].map((l) => {
      return window.parseInt(l.timestamp)
    })
    console.log('_getUrl_timestamp', c, state[c], tsList)
    const maxTimestamp = Math.max(...tsList)
    return `/api/v${v}/${c}/getupdated?t=${maxTimestamp}`
  }
}

const _readMasterFromDB = (c, exists, state) => {
  return new Promise((resolve) => {
    if (exists) {
      resolve({ value: undefined })
      return
    }
    const db = new ClientDB(conf.cacheStoreName)
    db.get(c).then((data) => {
      const toString = Object.prototype.toString
      let defValue
      if (toString.call(state[c]) === toString.call('')) {
        defValue = ''
      } else if (toString.call(state[c]) === toString.call([])) {
        defValue = []
      } else {
        defValue = {}
      }
      const value = (data === undefined) ? defValue : data.value
      console.log('__readMasterFromDB', c, conf.cacheStoreName, value, data)
      resolve({ c, value })
    })
  })
}

const _saveMasterToDB = (c, data) => {
  const db = new ClientDB(conf.cacheStoreName)
  db.register(c, data)
    .catch(e => {
      console.error(e)
    })
}

const _mergeData = (base, target) => {
  const tmp = base || []
  target.forEach(t => {
    const id = t.id
    const i = tmp.findIndex(e => {
      return e.id === id
    })
    if (i !== -1) {
      tmp[i] = t
    } else {
      tmp.push(t)
    }
  })

  const result = tmp.filter(e => {
    return !e.deleteFlg
  }).sort((a, b) => {
    if (a.id < b.id) { return -1 }
    if (a.id > b.id) { return 1 }
    return 0
  })
  return result
}

export const setMstUserSetting = ({ commit }, data) => {
  console.log('SET_USER_SETTINGS', types.SET_USER_SETTINGS, data)
  commit(types.SET_USER_SETTINGS, data)
}
